import axios from 'axios';

const { API_URL } = process.env;

const authRequested = axios.create({
  baseURL: API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
});

authRequested.interceptors.response.use(
  (response) => response,
  (error) => {
    return error.response; // Ensure full error is passed down
  }
);


export default authRequested;
